import { Routes, Route, Navigate } from 'react-router-dom';

import NotFoundPage from 'pages/NotFoundPage';

import PrivateRoute from './PrivateRoute';
import LoginRoute from './LoginRoute';
import routes from './routes';

const Router = () => (
  <Routes>
    {routes.public.map(route => (
      <Route exact key={route.path} path={route.path} element={route.component} />
    ))}
    {routes.private.map(route => (
      <Route exact key={route.path} path={route.path} element={<PrivateRoute />}>
        <Route exact path={route.path} element={route.component} />
      </Route>
    ))}
    <Route exact path="/" element={<Navigate to="/companies" />} />
    <Route exact path="/login" element={<LoginRoute />} />
    <Route exact path="*" element={<NotFoundPage />} />
  </Routes>
);

export default Router;
